import { render, staticRenderFns } from "./form_view.vue?vue&type=template&id=afd4ca36&"
import script from "./form_view.vue?vue&type=script&lang=js&"
export * from "./form_view.vue?vue&type=script&lang=js&"
import style0 from "./form_view.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports